import * as _ from "lodash";
import { Injectable } from "@angular/core";
import { InitialDataService } from "app/initial-data.service";


@Injectable()
export class FaresService {
    constructor(private initialDataService: InitialDataService) {

    }

    getFareBasisFor =  (passengerType: string, options) => {
        const fareTypes = this.initialDataService.fareTypes,
            //functions to be used to narrow down the list of fare types based on passenger type
            filters = {
                'adult'(fareType) {
                    return fareType.IsChild === false &&
                        fareType.IsInfant === false &&
                        fareType.ConcessionCardRequired === false;
                },
                'concession'(fareType) {
                    return fareType.IsChild === false &&
                        fareType.IsInfant === false &&
                        fareType.ConcessionCardRequired === true;
                },
                'accompaniedChild'(fareType) {
                    return fareType.IsChild === true &&
                        fareType.IsInfant === false &&
                        fareType.ConcessionCardRequired === false &&
                        fareType.NonChildRequired === true;
                },
                'infant'(fareType) {
                    return fareType.IsChild === true &&
                        fareType.IsInfant === true &&
                        fareType.ConcessionCardRequired === false &&
                        fareType.NonChildRequired === true;
                }
            };
        if (!_.isFunction(filters[passengerType])) {
            throw new Error(`"${passengerType}" is not a valid passenger type`);
        }


        this.validateOptions(options);
        var list: any = _.filter(fareTypes, filters[passengerType]);
        this.validateLength(passengerType, list);

        return options.isReturn ? list[0].ReturnCode : list[0].Code;
    };
    private validateOptions =  (options) => {
        if (!options && _.isUndefined(options.isReturn)) {
            throw new Error('option "isReturn" is required');
        }
    };
    private validateLength =  (passengerType, filteredFareTypes) => {
        if (!filteredFareTypes.length) {
            throw new Error(`No fare types were found for "${passengerType}"`);
        }
//        if (!(filteredFareTypes.length > 1)) {
//            throw new Error(`Multiple fare types were found for "${passengerType}"`);
//        }
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/services/fares.service.ts